import { useEffect, useState } from 'react'

import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import clsx from 'clsx'
import { observer } from 'mobx-react-lite'

import { preparePassengerByCloseCircle } from 'entities/beket/libs/preparePassengerByCloseCircle'
import {
  BeketPassengersValue,
  FormBeketPassengersValues,
} from 'entities/beket/models/form-passengers'
import { CloseCircle } from 'entities/close-circle/model'

import { CloseCircleApi } from 'shared/api/close-circle'
import { TYPE_AGE_BEKET } from 'shared/constants'
import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types.ts'
import { useDialogBottomSheet } from 'shared/ui/dialog-bottom-sheet/lib'
import { BlockSelect } from 'shared/ui/select/components/select-block'

import s from './styles.module.scss'

interface InfoForm {
  index: number
  typeAge: TYPE_AGE_BEKET
  isChild?: boolean
  isAbroad?: boolean
}

interface Props {
  passengerCount: number
  passengerAge?: string
  formInfo: InfoForm
}

export const FormHeader = observer(
  ({ passengerCount, passengerAge, formInfo }: Props) => {
    const { t } = useTranslation()

    const { closeDialog, openDialog } = useDialogBottomSheet()

    const { getValues, setValue } = useFormContext<FormBeketPassengersValues>()

    const [closeCircles, setCloseCircle] = useState<CloseCircle[]>()

    const getCircle = async () => {
      try {
        const { data: CloseCircle } = await CloseCircleApi.getUserDocuments()

        setCloseCircle(CloseCircle.data)
      } catch {}
    }

    useEffect(() => {
      getCircle()
    }, [])

    const formName = `${formInfo.typeAge}.${formInfo?.index}` as const

    const onShowCloseCircle = () => {
      const value: BeketPassengersValue = getValues(formName)

      const listCircle = closeCircles?.map((circle) => ({
        value: `${circle.id}`,
        name: `${circle?.label || ''}`,
      }))

      openDialog({
        child: (
          <div className={s.dialog}>
            <BlockSelect
              listOption={listCircle}
              value={{ value: `${value.id}`, name: '' }}
              onChange={(selected) => {
                const selectedCircle = closeCircles?.filter(
                  (circle) => circle.id === selected?.value,
                )[0]

                if (!selectedCircle) return

                const preparedPassenger = preparePassengerByCloseCircle({
                  isChild: formInfo?.isChild,
                  isAbroad: formInfo?.isAbroad,
                  closeCircle: selectedCircle,
                })

                // @ts-ignore
                setValue(formName, preparedPassenger)

                closeDialog()
              }}
            />
          </div>
        ),
      })
    }

    return (
      <div className={s.header}>
        <div className={s.left}>
          <p className={clsx(s.title, 'bold-17')}>
            {t('beket.passenger', { count: passengerCount })}
          </p>
          <p className={clsx(s.subtitle, 'regular-12')}>{passengerAge}</p>
        </div>

        {(closeCircles?.length || 0) > 0 && (
          <p
            className={s.right}
            onClick={onShowCloseCircle}
          >
            <AppIcon
              className={s.icon}
              id={AllIcons.PERSONS}
            />
            {t('сlose_circlу')}
          </p>
        )}
      </div>
    )
  },
)
